import { N_ } from '../i18n';
/**
 * Highlight styles the visitor can choose in Settings. Applied through CSS
 * custom properties so both rendering paths (CSS Custom Highlight API and DOM
 * spans) pick them up without re-rendering.
 */
export type HighlightMode = 'wordsent' | 'word' | 'sent' | 'none';

export interface HighlightSwatch {
  id: string;
  label: string;
  bg: string;        // background ('transparent' for underline)
  fg: string;        // text color
  underline?: boolean;
}

export const WORD_SWATCHES: HighlightSwatch[] = [
  { id: 'navy', label: N_('Navy'), bg: '#1a3a6b', fg: '#ffffff' },
  { id: 'yellow', label: N_('Yellow'), bg: '#ffeb3b', fg: '#000000' },
  { id: 'green', label: N_('Light green'), bg: '#beffd6', fg: '#000000' },
  { id: 'blue', label: N_('Light blue'), bg: '#a4cbff', fg: '#000000' },
  { id: 'pink', label: N_('Pink'), bg: '#fbd0e4', fg: '#000000' },
  { id: 'underline', label: N_('Underline'), bg: 'transparent', fg: 'inherit', underline: true },
];

export const SENTENCE_SWATCHES: HighlightSwatch[] = [
  { id: 'yellow', label: N_('Light yellow'), bg: '#fff176', fg: '#1a1a1a' },
  { id: 'green', label: N_('Light green'), bg: '#dcfce7', fg: '#1a1a1a' },
  { id: 'blue', label: N_('Light blue'), bg: '#dbeafe', fg: '#1a1a1a' },
  { id: 'pink', label: N_('Pink'), bg: '#fce7f3', fg: '#1a1a1a' },
  { id: 'gray', label: N_('Gray'), bg: '#e5e7eb', fg: '#1a1a1a' },
  { id: 'underline', label: N_('Underline'), bg: 'transparent', fg: 'inherit', underline: true },
];

export const HIGHLIGHT_MODES: { id: HighlightMode; label: string }[] = [
  { id: 'wordsent', label: N_('Word & sentence') },
  { id: 'word', label: N_('Word only') },
  { id: 'sent', label: N_('Sentence only') },
  { id: 'none', label: N_('Off') },
];

export function swatch(list: HighlightSwatch[], id: string | undefined): HighlightSwatch {
  return list.find(s => s.id === id) || list[0];
}
